import React from 'react';
import PropTypes from 'prop-types';
import { basePageWrap } from '../BasePage';
import CampaignHero from '../../components/CampaignHero/CampaignHero';
import StreamField from '../../components/StreamField';
import styles from './CampaignPage.module.scss';
import Head from 'next/head';

const CampaignPage = ({
    campaignHero,
    blocks = [],
    topBlocks = [],
    bottomBlocks = [],
    title,
    searchDescription,
    seo,
}) => {
    const campaignSchema = {
        '@context': 'https://schema.org',
        '@type': 'Event',
        name: title || '',
        description: searchDescription || '',
        image: seo.seoOgImage || '',
        url: seo.seoOgUrl || '',
        startDate: campaignHero.eventDateStart || '',
        endDate: campaignHero.eventDateEnd || '',
    };

    return (
        <>
            <Head>
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify(campaignSchema),
                    }}
                />
            </Head>
            <div className={styles['Root']}>
                <CampaignHero {...campaignHero} />
                <div className={styles['TopBlocks']}>
                    <StreamField blocks={topBlocks} />
                </div>
                <div className={styles['Overflow']}>
                    <StreamField blocks={blocks} />
                </div>
                <div className={styles['BottomBlocks']}>
                    <StreamField blocks={bottomBlocks} />
                </div>
            </div>
        </>
    );
};

CampaignPage.propTypes = {
    title: PropTypes.string.isRequired,
    siteSetting: PropTypes.object,
    isDesktop: PropTypes.bool,
    campaignHero: PropTypes.object,
    blocks: PropTypes.array,
    topBlocks: PropTypes.array,
};

export default basePageWrap(CampaignPage);
